import { css } from '@emotion/react';
import { CssVars, Modal, NeutralColorToken, SemanticColorToken, Type } from '@robinhood/design';
import { RowUtils } from '@robinhood/design/product/components/Rows/RowUtils';

import Button from 'src/components/creditApplication/Button';
import { useIsNfaStanford } from 'src/hooks/useAttribution';

interface PropsIface {
  onDismiss: () => void;
}

interface RowProps {
  text: string;
}

const IncludedRow = ({ text }: RowProps) => {
  return (
    <div css={row}>
      <RowUtils.Icon type='BubbleChecked24' color={SemanticColorToken.Positive} />
      <Type.Text size='M'>{text}</Type.Text>
    </div>
  );
};

const ExcludedRow = ({ text }: RowProps) => {
  return (
    <div css={row}>
      <RowUtils.Icon type='BubbleRemoveFilled24' color={NeutralColorToken.Fg3} />
      <Type.Text size='M'>{text}</Type.Text>
    </div>
  );
};

const StudentIncomeContent = () => {
  return (
    <div>
      <div css={dialogSection}>
        <Type.Text size='M' isBold>
          Include all pre-tax income such as:
        </Type.Text>
        <IncludedRow text='Base pay' />
        <IncludedRow text='Tips, bonuses, commission' />
        <IncludedRow text='Scholarships, grants, financial aid minus any amount owed for education' />
        <IncludedRow text='Money regularly deposited into your account' />
        <IncludedRow text='Any other income source' />
      </div>
    </div>
  );
};

const DefaultIncomeContent = () => {
  return (
    <div>
      <div css={[dialogSection, { borderBottom: `1px solid ${CssVars.neutral.bg3}` }]}>
        <Type.Text size='M' isBold>
          Include all pre-tax income, like:
        </Type.Text>
        <IncludedRow text='Annual base salary' />
        <IncludedRow text='Annual bonus, if applicable' />
      </div>
      <div css={dialogSection}>
        <Type.Text size='M' isBold>
          Don’t include:
        </Type.Text>
        <ExcludedRow text='RSUs, stocks, or options' />
        <ExcludedRow text='Investment income' />
      </div>
    </div>
  );
};

const IncomeModal = ({ onDismiss }: PropsIface) => {
  const isNfaStanford = useIsNfaStanford();
  const content = isNfaStanford ? <StudentIncomeContent /> : <DefaultIncomeContent />;
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      {content}
      <div css={buttonContainer}>
        <Button label='Dismiss' width='full' type='button' onClick={onDismiss} />
      </div>
    </Modal>
  );
};

const root = css`
  padding: 0px;
`;

const dialogSection = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

const row = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const buttonContainer = css`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 40px;
`;

export default IncomeModal;
